/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateTipDeclarationSettings} from '../api'

export const useMutationUpdateTipDeclarationSettings = createReactQueryMutationHook('updateTipDeclarationSettings', updateTipDeclarationSettings)
